import { Alert } from '@/global/components/Alert'
import Grid from '@/global/components/ui/Grid'
import { FormDatePicker } from 'global/components/Form'
import { SelectEmpresa } from 'global/components/Selects'
import TabFuncionariosForm from 'templates/ManutencaoDoPonto/Digitacao/atoms/TabsFuncionarios'

interface Props {
    checked?: number[]
}

export default function FormAssociarFuncionarios({ checked }: Props) {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Alert severity="info">
                    A vinculação de funcionários é opcional. Você pode
                    associá-los agora ou depois, editando esta tabela ou pelo
                    menu de troca de tabela de horário.
                </Alert>
            </Grid>
            <Grid item xs={12}>
                <SelectEmpresa variant="form" hideWhenSingle />
            </Grid>
            <TabFuncionariosForm
                formName="funcionarios.funcionarioIds"
                checked={checked}
            />
            <Grid item xs={6}>
                <FormDatePicker
                    label="Data inicial"
                    name="funcionarios.dtInicial"
                    type="date"
                    required
                />
            </Grid>
            <Grid item xs={6}>
                <FormDatePicker
                    label="Data final"
                    name="funcionarios.dtFinal"
                    type="date"
                    helperText="Deixe em branco para indeterminado"
                />
            </Grid>
        </Grid>
    )
}
